module.exports = __webpack_public_path__ + "icon-download@2x.png?f26dec04b43d2578cdb76b1b8d16877e";